export enum ShiftDirectionEnum {
  Left = 'Left',
  Right = 'Right',
}
